/**
 * External File Search Agent - System Prompt Builder
 *
 * Assembles the 5-section system prompt for the External File Search agent.
 */
import { SystemPromptBuilder } from '../../../base/systemPrompt';
import { getIntroSection, EXTERNAL_FILE_INTRO } from './intro';
import { buildToolsSection } from './tools';
import { getSuggestionsSection, EXTERNAL_FILE_SUGGESTIONS } from './suggestions';
import { getContextNoteSection, EXTERNAL_FILE_CONTEXT_NOTE } from './contextNote';
import { getEvaluationSection, EXTERNAL_FILE_EVALUATION } from './evaluation';
/**
 * Build the complete system prompt for the External File Search agent.
 * Uses Keywords AI prompts if available, with code fallbacks.
 */
export function buildExternalFileSystemPrompt(params = {}) {
    const hasContext = params.resolvedContext && params.resolvedContext.length > 0;
    const builder = new SystemPromptBuilder();
    let prompt = builder.build({
        intro: getIntroSection(),
        tools: buildToolsSection(params.tools),
        suggestions: getSuggestionsSection(),
        contextNote: getContextNoteSection(hasContext),
        evaluation: getEvaluationSection(),
    });
    // Append resolved context if available
    if (hasContext && params.resolvedContext) {
        const contextDescriptions = params.resolvedContext.map(item => {
            const ids = Array.from(item.resolved.keys()).join(', ');
            return `- ${item.original.purpose} (IDs: ${ids})`;
        }).join('\n');
        prompt += `\n\n## Available Context\n${contextDescriptions}`;
    }
    return prompt;
}
// Export all sections for admin panel access
export { getIntroSection, buildToolsSection, getSuggestionsSection, getContextNoteSection, getEvaluationSection, EXTERNAL_FILE_INTRO, EXTERNAL_FILE_SUGGESTIONS, EXTERNAL_FILE_CONTEXT_NOTE, EXTERNAL_FILE_EVALUATION, };
// Variables and prompt configuration
export { EXTERNAL_FILE_SEARCH_VARIABLES, EXTERNAL_FILE_SEARCH_PROMPT_KEYS, EXTERNAL_FILE_SEARCH_PROMPT_CONFIG, } from './variables';
